export default {
  namespaced: true,
  state: {
    safeNum: {sat: 0, sab: 0, sar: 0, sal: 0},
    pageTitle: '',
    webWithoutNavigation: true
  },
  mutations: {
    SET_SAFE_NUM (state, val) {
      state.safeNum = Object.assign(state.safeNum, val)
    },
    SET_PAGE_TITLE (state, val) {
      document.title = val
      state.pageTitle = val
    },
    SET_HAS_NAVIGATION (state, bol) {
      state.webWithoutNavigation = bol
    }
  }
}
